import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ProcessoRiscosLista } from "../../../../domain/models/processos_riscos_lista";
import { defaultProcessoRiscosCopiaForm, QualidadeProcessoRiscosCopiaForm, QualidadeProcessoRiscosCopiaSchema } from "../../../schemas/ProcessosRiscos/qualidade_processos_riscos_copia";


type props = {
    open: boolean,
    saving: boolean,
    selectedProcessoRiscosCopia: ProcessoRiscosLista | undefined,
    titulo: string,
    onClose: () => void,
    onSubmit: (form: QualidadeProcessoRiscosCopiaForm) => void,

}

export const CopiaProcessoRiscoModal = ({
    open,
    saving,
    selectedProcessoRiscosCopia,
    titulo,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<QualidadeProcessoRiscosCopiaForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultProcessoRiscosCopiaForm,
        resolver: zodResolver(QualidadeProcessoRiscosCopiaSchema),
    });

    useEffect(() => {
        if (selectedProcessoRiscosCopia) {
            hookForm.setValue('IdProcessos', selectedProcessoRiscosCopia.IdProcesso);
            hookForm.setValue('ano', Number(selectedProcessoRiscosCopia.Ano));
        }

    }, [titulo, hookForm, selectedProcessoRiscosCopia]);

    const handleSubmit = useCallback((form: QualidadeProcessoRiscosCopiaForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Copiar Auditoria
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <DefaultFormInput
                                name='ano'
                                label='Ano'
                                reactHookForm={hookForm}

                            />
                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}